const WineImageFullscreenModal = ({
  wine,
  isFullScreen,
  canHoverZoom,
  scale,
  position,
  isDragging,
  fullScreenImageRef,
  closeFullScreen,
  resetZoom,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  handleDoubleTap,
}) => {
  if (!canHoverZoom || !isFullScreen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center touch-none"
      style={{ animation: 'fadeIn 0.3s ease-out' }}
    >
      <div
        className="absolute inset-0 bg-black/95 backdrop-blur-md"
        onClick={closeFullScreen}
      />

      <div
        className="relative z-10 flex flex-col items-center w-full h-full p-4 overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onClick={handleDoubleTap}
      >
        <div className="text-center mb-4 flex-shrink-0 pointer-events-none" style={{ animation: 'slideDown 0.4s ease-out' }}>
          <h2 className="text-2xl md:text-4xl font-serif text-wine-gold mb-1">{wine.name}</h2>
          <p className="text-gray-400 text-sm md:text-lg">{wine.grape} • {wine.region}</p>
        </div>

        <div
          ref={fullScreenImageRef}
          className="relative flex-1 flex items-center justify-center w-full overflow-hidden"
          style={{ animation: 'zoomIn 0.4s ease-out' }}
        >
          <img
            src={wine.image}
            alt={wine.name}
            className="max-h-[65vh] md:max-h-[70vh] w-auto object-contain select-none"
            style={{
              filter: 'drop-shadow(0 25px 50px rgba(0, 0, 0, 0.5))',
              transform: `scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`,
              transition: isDragging ? 'none' : 'transform 0.2s ease-out',
              touchAction: 'none',
            }}
            draggable={false}
          />
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-wine-gold/20 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-wine-gold/10 rounded-full blur-2xl pointer-events-none" />
        </div>

        <div className="mt-4 flex-shrink-0 pointer-events-none" style={{ animation: 'fadeIn 0.6s ease-out' }}>
          <span className="hidden md:flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full text-gray-500 text-sm">
            <kbd className="bg-white/10 px-2 py-0.5 rounded text-xs">ESC</kbd>
            ou clique para fechar
          </span>
          <div className="flex md:hidden flex-col items-center gap-1 text-gray-500 text-xs">
            <span className="bg-white/5 px-3 py-1.5 rounded-full">
              👆 Toque duplo para zoom • Arraste para mover
            </span>
            {scale > 1 && (
              <span className="text-wine-gold/70">Zoom: {scale.toFixed(1)}x</span>
            )}
          </div>
        </div>
      </div>

      <button
        onClick={closeFullScreen}
        className="absolute top-4 right-4 md:top-6 md:right-6 z-20 bg-black/60 hover:bg-black/80 text-white transition-all p-4 md:p-3 rounded-full shadow-lg active:scale-95"
        style={{ minWidth: '56px', minHeight: '56px' }}
        aria-label="Fechar"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {scale > 1 && (
        <button
          onClick={resetZoom}
          className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 bg-wine-gold/90 hover:bg-wine-gold text-black font-semibold transition-all px-6 py-3 rounded-full shadow-lg active:scale-95 flex items-center gap-2"
          aria-label="Resetar zoom"
        >
          Resetar
        </button>
      )}
    </div>
  );
};

export default WineImageFullscreenModal;
